import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ProdutividadeIndiceService } from '../produtividade-indice-service/produtividade-indice.service';
import { ListaBase } from '././../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from '././../../../../shared/gridview/EstruturaGridViewBuilder';

@Component({
    selector: 'app-produtividade-indice-lista',
    templateUrl: '../../template/lista.html',
    styleUrls: ['./produtividade-indice-lista.component.css']
  })
export class ProdutividadeIndiceListaComponent extends ListaBase implements OnInit {

    visualizarTotalRegistros: boolean;
    exibirBotaoDetalhes: boolean;

    constructor(service: ProdutividadeIndiceService, toastr: ToastrService, router: Router) {
        super(service, toastr, router);

        this.visualizarTotalRegistros = true;
        this.exibirBotaoDetalhes = true;
        this.exibirBotaoNovo = false;
        this.exibirBotaoDefinirFiltros = false;
    }

    ngOnInit() {
        this.buscar();

        this.estrutura = new EstruturaGridViewBuilder()
            .addColuna('fabrica', 'parametros.indiceProdutividade.fabrica')
            .addColunaCentralizada('maoDeObra', 'parametros.indiceProdutividade.produtividadeHeader')
            .addColunaCentralizada('produtividade', 'parametros.indiceProdutividade.eficienciaHeader')
            .addColunaCentralizada('eficiencia', 'parametros.indiceProdutividade.utilizacaoHeader')
            .build();
    }

    protected getListagemComFiltros(): boolean {
        return false;
    }

}